import {DataPadButton} from "./Elements/Buttons";
import {VolumeIndicator} from "./Elements/VolumeIndicator";
import {MiniPanel} from "./Elements/MiniPanel";
import {FrameSection} from "./Elements/FrameSection";
import styled from "styled-components";
import {Colors} from "./Colors";
import {VolumeSet} from "./Elements/VolumeSet";

export const Elements = {

	FrameSection: FrameSection,

	Frames: {
		Section: FrameSection,
		SectionTitle: styled.div`
			display: block;
			margin-bottom: 16px;
		
			color: ${ Colors.raw.neon_orange };
			font-family: "Courier New", monospace;
			font-size: 13px;
			font-weight: 700;
			letter-spacing: 2.2px;
			line-height: 17px;
			text-transform: uppercase;
		
			text-shadow: 0 0 8px rgba(230, 112, 26, 0.22);
		`,
	},

	Buttons: DataPadButton,
	VolumeIndicator: VolumeIndicator,
	VolumeSet: VolumeSet,

	MiniPanel: MiniPanel
};